<template>
  <v-col>
    {{ showCalculationState }}
    <v-progress-linear
      v-model="recalculationState.progress"
      color="primary"
      height="8"
      striped
    ></v-progress-linear>
  </v-col>
</template>
  
  <script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "DisplayCalculationStateComponent",
  computed: {
    ...mapState("weatherRouting/voyageDetailsModule", [
      "fetchSolutionsLoading",
      "recalculationLoading",
      "voyageSolutions",
      "recalculationState",
    ]),
    ...mapGetters("weatherRouting/voyageDetailsModule", ["fetchRequestFailed"]),
    showCalculationState() {
      if (this.recalculationState.stateValue == 0) {
        return this.recalculationState.stateTitle;
      } else if (
        this.recalculationState == undefined ||
        this.recalculationState == ""
      ) {
        return "";
      } else {
        const progress =
          this.recalculationState.progress > 0
            ? `(${this.recalculationState.progress}%)`
            : "";
        return `${this.recalculationState.stateTitle}...${progress}`;
      }
    },
  },
};
</script>